import { render, staticRenderFns } from "./accessibility.vue?vue&type=template&id=6b4aa667&scoped=true&"
import script from "./accessibility.vue?vue&type=script&lang=js&"
export * from "./accessibility.vue?vue&type=script&lang=js&"
import style0 from "./accessibility.vue?vue&type=style&index=0&id=6b4aa667&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4aa667",
  null
  
)

export default component.exports